// extracted by mini-css-extract-plugin
export default {"hero":"HeroTitleChip_hero__6+UIY","heroImg":"HeroTitleChip_heroImg__ztZxy","chip":"HeroTitleChip_chip__3YaiE","title":"HeroTitleChip_title__KiJxo"};